<div class="layout-footer">
    <img src="assets/layout/images/logo.png" alt="Logo" height="20" class="mr-2"/>
    Sistema Desarrollado por
    <a href="https://www.xperia.com" class="font-medium ml-2" target="_blank">Xperia SRL</a>
</div>
